import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as d3 from 'd3';
import { DataBridgeService } from '../../../services/data-bridge.service';

@Component({
  selector: 'app-svg-factory',
  templateUrl: './svg-factory.component.html',
  styleUrls: ['./svg-factory.component.scss']
})
export class SvgFactoryComponent implements OnInit {
  @Input() FLOOR_DATA;
  @Input() svgComponent;
  @Input() data;
  @Input() floorDetails;
  @Input() mouseEvent;
  @Input() floorType;
  @Input() seatID;
  @Output() finishedSVGInjection: EventEmitter<any> = new EventEmitter<any>();
  polygonCount = 0;
  PADDING: number = 0;
  floorImage: string | ArrayBuffer;
  assetsLocation: any;
  inMemoryAsset: any={};
  view;
  assetsCache = {}
  assetsUrls = []
  @Input() empGuid: string = ''
  constructor(private _dataService: DataBridgeService) { }

  ngOnInit() {
    this.assetsLocation = this._dataService.getAssetsLocation();
    let that = this;
    let groups = d3.select(this.svgComponent).selectAll("g")
    let assetPlacementPromises = [];
    // ADD SEATS AMD ROOMS
    if (this.floorType == "WITH_FLOOR_PLAN") {
      groups.each(function seatAssignment(d: any, i) {
        if (d['properties']?.type == "SEAT") {
          that.assetsUrls.push(that.constructSeatImageUrl(d))
        }
      });
      let uniqueSvgUrls = new Set(this.assetsUrls)
      this.assetsUrls = Array.from(uniqueSvgUrls)
      let assetsPromises = this.assetsUrls.map((url) => {
        return new Promise((res, rej) => {
          d3.xml(url).then((data)=>{
            let svgString = new XMLSerializer().serializeToString(data)
            this.assetsCache[url] = svgString
            res(true)
          }).catch((err) => {
            res(true)
          })
        })
      })
      Promise.all(assetsPromises).then(() => {
        groups.each(function seatAssignment(d: any, i) {
          that.polygonCount += 1;
          if (d['properties']?.type == "SEAT") {
            assetPlacementPromises.push(that.styliseSeats(d, this))
          } else if (d['properties']?.type == "ROOM") {
            that.styliseRoom(d, this)
          }else{
            that.styliseObstacle(d,this);
          }
        });

        // PLOT DOOR ANCHORS
        this.pluginDoors()
        groups.transition().duration(2000).style("opacity", "1");
        Promise.all(assetPlacementPromises).then(()=>{
          this.finishedSVGInjection.emit();
        }).catch((err) => {
          this.finishedSVGInjection.emit();
        })
        if (this.data.image) {
          this.placeFloorImage();
        }
      }).catch((err) => {
        this.finishedSVGInjection.emit();
      })
    } else if (this.floorType == "WITH_BACKGROUND_IMAGE") {
      this.placeFloorImage();
      d3.select(this.svgComponent).selectAll("g").each(function seatAssignment(d, i) {
        if (d['properties']?.type == "SEAT") {
          that.assetsUrls.push(that.constructSeatImageUrl(d))
        }
      });
      let uniqueSvgUrls = new Set(this.assetsUrls)
      this.assetsUrls = Array.from(uniqueSvgUrls)
      let assetsPromises = this.assetsUrls.map((url) => {
        return new Promise((res, rej) => {
          d3.xml(url).then((data)=>{
            let svgString = new XMLSerializer().serializeToString(data)
            this.assetsCache[url] = svgString
            res(true)
          }).catch((err) => {
            res(true)
          })
        })
      })
      Promise.all(assetsPromises).then(() => {
        let groups = d3.select(this.svgComponent).selectAll("g").each(function seatAssignment(d, i) {
          if (d['properties']?.type == "SEAT") {
            assetPlacementPromises.push(that.styliseSeats(d, this));
          }
        });
        Promise.all(assetPlacementPromises).then(()=>{
          // groups.transition().duration(1000).style("opacity", "1").on("end", ()=>{
          this.finishedSVGInjection.emit();
          // }
          // );
        }).catch((error)=>{
          this.finishedSVGInjection.emit();
        })
      }).catch((err) => {
        this.finishedSVGInjection.emit();
      })
    }
  }

  placeFloorImage() {
    let promise = new Promise((resolve, reject) => {
      try {
        let image = this.data.image
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onloadend = () => {
          let floorBoundaryPath = document.getElementById(this.floorDetails.floorId)
          let floorBoundaryGroup = floorBoundaryPath?.parentElement
          let image = d3.select(floorBoundaryGroup).append("image")
            .attr("href", reader?.result?.toString())
            .attr("id", this.floorDetails.floorId)
            .style("width", (d, i) => {
              return d3.select(this.svgComponent).attr("width")
            })
            .style("height", (d, i) => {
              return d3.select(this.svgComponent).attr("height")
            })
            .attr("width", (d, i) => {
              return d3.select(this.svgComponent).attr("width")
            })
            .attr("height", (d, i) => {
              return d3.select(this.svgComponent).attr("height")
            })
            .style("opacity", "0")
            .transition().duration(1500)
            .style("opacity", '1');
          resolve(image)
        }
      } catch (Exception) {
        reject(Exception)
      }
    })
    return promise
  }
  styliseObstacle(d: any, base: d3.BaseType){
    d3.select(base).style("opacity", "0");
  }
  styliseRoom(d: any, base: d3.BaseType) {
    return new Promise((resolve, reject) => {
      let floorOffsetLeft = document
        .getElementById(this.floorDetails.floorId)
        .getBoundingClientRect().left;
      let floorOffsetTop = document
        .getElementById(this.floorDetails.floorId)
        .getBoundingClientRect().top;
      let NODE = document.getElementById(d['properties'].ID);
      let width = NODE.getBoundingClientRect().width;
      let height = NODE.getBoundingClientRect().height;
      let xMid = (NODE.getBoundingClientRect().left - floorOffsetLeft) + (width / 2);
      let yMid = (NODE.getBoundingClientRect().top - floorOffsetTop) + (height / 2);
  
      d3.select(base).selectAll("path")
        .style('fill', function (d, i) {
          if (d['properties'].type == "ROOM") {
            return d['styling']?.colorCode || "#E9ECEE";
          }
        })
      d3.select(base).attr('type', "ROOM")
        .append("text")
        .text( d.styling?.displayName || '')
        .attr("fill", "#565a71")
        .attr("x", xMid)
        .attr("y", yMid)
        .attr("dominant-baseline", "central")
        .attr("text-anchor", "middle")
        .style('transform-origin', `${xMid}px ${yMid}px`)
        .style('font-family', 'Lato,sans-serif')
        .style('font-size', this._dataService.getSinglePointSize() * 0.35);
  
         // APPEND BASE IMAGE
        d3.select(base).append("image")
          .attr("href", (d,i)=>{
            if (d['styling']?.baseImage) {
                return this.assetsLocation + '/' + (d['styling']?.baseImage);
            }
           })
           .attr("width", width - this.PADDING)
           .attr("height", height - this.PADDING)
           .attr("x", xMid - (width / 2) + this.PADDING / 2)
           .attr("y", yMid - (height / 2) + this.PADDING / 2);
      // APPEND INNER IMAGE
      d3.select(base).append("image")
        .attr("href", (d,i)=>{
            if (d['styling']?.innerImage ||  d['styling']?.imageName) {
                return this.assetsLocation + '/' + ( d['styling']?.innerImage ||  d['styling']?.imageName);
            }
        })
        .attr("width", (width * 0.5) - this.PADDING)
        .attr("height", (height * 0.5) - this.PADDING)
        .attr("x", xMid - ((width * 0.5) / 2) + this.PADDING / 2)
        .attr("y", yMid - ((height * 0.5) / 2) + this.PADDING / 2)
        .style('transform-origin', `${xMid}px ${yMid}px`)
        .style('transform', function(d, i) {
            return 'rotate(' + (d['styling'].angle || 0) + 'deg)';
        });
    })
  }


  pluginDoors() {
    let that = this;
    let doorPoints = d3.select(this.svgComponent).selectAll("g").each(function seatAssignment(d: any, i) {
      if (d3.select(this).attr('type') == "door") {
        d3.select(this)
          .attr("width", "4px")
          .attr("height", "4px");

        d3.xml(`${that.assetsLocation}/${d3.select(this).select("circle").attr('image')}`)
          .then((data: any) => {
            d3.select(this).append('g')
              .style("transform-origin", () => {
                let originOffset = that._dataService.getSinglePointSize() / 2
                return `${parseFloat(d3.select(this).select("circle").attr('cx')) + originOffset}px 
                ${parseFloat(d3.select(this).select("circle").attr('cy')) + originOffset}px`
              })
              .style("transform", `rotate(${d3.select(this).select("circle").attr('angle')}deg) translate(${parseFloat(d3.select(this).select("circle").attr('cx'))}px, ${parseFloat(d3.select(this).select("circle").attr('cy'))}px)`)
              .append(() => {
                d3.select(data.documentElement)
                  .attr("width", that._dataService.getSinglePointSize())
                  .attr("height", that._dataService.getSinglePointSize())
                return data.documentElement
              })

            d3.select(this).select("circle").attr('opacity', '0')
          });
      }
    });
  }
  constructSeatImageUrl(d: any){
    this.view = this.getQueryStringValue("view");
    let bookingEmpGuid = (d.properties.bookedByDetails && d.properties.bookedByDetails[0]?.empGuid) ? d.properties.bookedByDetails[0].empGuid: ''
    // TODO: Get the view from emp exp
    this.view = this.getQueryStringValue("view");
    let ID = d['properties'].ID
    let team = this.getTeamName(d['properties'].ID)
    let currentImageName = d.styling?.imageName || (this.floorType == "WITH_FLOOR_PLAN" ? 'availableSeatDefault' : 'point');
    // if (ID == this.seatID) {
    //   // currentImageName+= "Selected";
    //   currentImageName+= "Booked";
    // }
    if (this.empGuid === bookingEmpGuid){
      if(this.floorType == "WITH_BACKGROUND_IMAGE") currentImageName += "assigned";
      else currentImageName+= "PastBooked";
    }
    else {
      if(this.view =="admin-view"){


        if(d['properties'].status == 'Not Available' && d['properties'].bookedByDetails==undefined && d['properties'].groupType==undefined){
          currentImageName+= 'Unavailable';
        }else{
          if(d.properties.status=="BOOKED" || d.properties.status=="CONFIRMED"){
            if(team){
              this.FLOOR_DATA.extras.colorMapping.forEach(label=>{
                if(Object.keys(label)[0]==team){
                  currentImageName = 'team/'+label[team]+'/'+currentImageName;
                }
              });
              currentImageName+= "Booked";
            }else{
              currentImageName+= "Booked";
            }
          }else{
            if(d.properties.status=="SIGNED_IN"){
              if(team){
                this.FLOOR_DATA.extras.colorMapping.forEach(label=>{
                  if(Object.keys(label)[0]==team){
                    currentImageName = 'team/'+label[team]+'/'+currentImageName;
                  }
                });
                currentImageName+= "Signedin";
              }else{
                currentImageName+= "Signedin";
              }
            }else{
              if(d.properties.status=="AVAILABLE" || d.properties.status=="Not Available"){
                if(d['properties']?.groupType=="EMPLOYEE"){
                  currentImageName+= "assigned";
                }else{
                  if(d['properties']?.groupType=="HOTSEAT"){
                    currentImageName;
                  }else{
                    if(d.properties.groupType=='BLOCKED' ){
                      currentImageName+= "Unavailable";
                    }else{
                      if(d['properties']?.groupType=="TEAM" || d['properties']?.teamName){
                        this.FLOOR_DATA.extras.colorMapping.forEach(label=>{
                          if(Object.keys(label)[0]==team){
                            currentImageName = 'team/'+label[team]+'/'+currentImageName;
                          }
                        });
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }else{

        /** Assignement view asset mapping for 'with floor plan" */
        if(this.view=="assignment-view"){
          if(d.properties.groupType){
            if(d.properties.groupType=="EMPLOYEE"){
              if(d.properties?.bookedByDetails.length>0 && d.properties?.bookedByDetails[0].teamName){
                this.FLOOR_DATA.extras.colorMapping.forEach(label=>{
                  if(Object.keys(label)[0]==team){
                    currentImageName = 'team/'+label[team]+'/'+currentImageName;
                  }
                });
                currentImageName+= "Booked";

              }
            }else{
              if(d.properties.groupType=="TEAM"){
                this.FLOOR_DATA.extras.colorMapping.forEach(label=>{
                  if(Object.keys(label)[0]==team){
                    currentImageName = 'team/'+label[team]+'/'+currentImageName;
                  }
                });
                currentImageName+= "Booked";
              }else{
                if(d.properties.groupType=="HOTSEAT"){
                  currentImageName = currentImageName;
                }else{
                  if(d.properties.groupType=="BLOCKED"){
                    currentImageName+= 'Unavailable';
                  }else{
                    if(d.properties.getTeamName=="AVAILABLE"){
                      currentImageName = currentImageName;
                    }
                  }
                }
              }
            }

          }
        }else if(this.view === 'sanitisation-view'){
          d.properties.isSanitized ? currentImageName += 'Sanitized' : currentImageName += 'Unsanitized';
        }
        else if(this.view === 'preferences-view'){
            switch (d.properties.status) {
              case 'Not Available':
                  currentImageName+= "Unavailable";
                  break;
              case 'AVAILABLE':
                  currentImageName = currentImageName;
                  break;
              case 'BOOKED':
                  if(d.properties.groupType === 'TEAM' || d.properties.groupType === 'HOTSEAT'){
                    currentImageName = currentImageName;
                  }
                  else currentImageName+= "Booked";
                  break;
              case 'SIGNED_IN':
                  if(d.properties.groupType === 'TEAM' || d.properties.groupType === 'HOTSEAT'){
                    currentImageName = currentImageName;
                  }
                  else currentImageName+= "Signedin";
                  break;
          }
        }
        else{
          /**Employee view asset mapping for 'with floor plan""*/
          switch (d.properties.status) {
            case 'Not Available':
              currentImageName+= "Unavailable";
              break;
            case 'AVAILABLE':
              currentImageName = currentImageName;
              break;
            case 'BOOKED':
              currentImageName+= "Booked";
              break;
            case 'SIGNED_IN':
              currentImageName+= "Signedin";
          }
        }
      }
    }
    return `${this.assetsLocation}/${currentImageName}.svg`
  }
  styliseSeats(d: any, baseGroup: d3.BaseType) {

    let bookingEmpGuid = (d.properties.bookedByDetails && d.properties.bookedByDetails[0]?.empGuid) ? d.properties.bookedByDetails[0].empGuid: ''
    // TODO: Get the view from emp exp
    this.view = this.getQueryStringValue("view");
    let ID = d['properties'].ID
    let NODE = document.getElementById(ID);
    let styles = d.styling;
    // let team = d['properties']?.teamName || d['properties'].bookedByDetails?.teamName;
    // let team = d['properties']?.teamName;
    let team = this.getTeamName(d['properties'].ID)
    // let team = (d['properties']?.groupType=='TEAM' || (d['properties'].groupType==null && d['properties'].teamName))?d['properties']?.teamName:null;
    // console.log(team);
    let seatColorCode = (this._dataService.getColorMapping() && team) ? this._dataService.getColorMapping()[team] : null;
    if (seatColorCode)
        console.log(seatColorCode);
        
    let floorOffsetLeft = document
      .getElementById(this.floorDetails.floorId)
      ?.getBoundingClientRect().left;
    let floorOffsetTop = document
      .getElementById(this.floorDetails.floorId)
      ?.getBoundingClientRect().top;
    let xPos = NODE?.getBoundingClientRect().left - floorOffsetLeft ;
    let yPos = NODE?.getBoundingClientRect().top - floorOffsetTop ;
    let width = NODE?.getBoundingClientRect().width ;
    let height = NODE?.getBoundingClientRect().height ;
    let currentImageName = d.styling?.imageName || (this.floorType == "WITH_FLOOR_PLAN" ? 'availableSeatDefault' : 'point');

    // if (ID == this.seatID) {
    //     // currentImageName+= "Selected";
    //     currentImageName+= "PastBooked";
    // }
    if (this.empGuid === bookingEmpGuid){
      if(this.floorType == "WITH_BACKGROUND_IMAGE") currentImageName += "assigned";
      else currentImageName+= "PastBooked";
    }
    else {

      /** Admin view asset mapping for 'with floor plan" */
      if(this.view =="admin-view"){


        if(d['properties'].status == 'Not Available' && d['properties'].bookedByDetails==undefined && d['properties'].groupType==undefined){
          currentImageName+= 'Unavailable';
        }else{
          if(d.properties.status=="BOOKED" || d.properties.status=="CONFIRMED"){
            if(team){
              this.FLOOR_DATA.extras.colorMapping.forEach(label=>{
                if(Object.keys(label)[0]==team){
                  currentImageName = 'team/'+label[team]+'/'+currentImageName;
                }
              });
              currentImageName+= "Booked";
            }else{
              currentImageName+= "Booked";
            }
          }else{
            if(d.properties.status=="SIGNED_IN"){
              if(team){
                this.FLOOR_DATA.extras.colorMapping.forEach(label=>{
                  if(Object.keys(label)[0]==team){
                    currentImageName = 'team/'+label[team]+'/'+currentImageName;
                  }
                });
                currentImageName+= "Signedin";
              }else{
                currentImageName+= "Signedin";
              }
            }else{
              if(d.properties.status=="AVAILABLE" || d.properties.status=="Not Available"){
                if(d['properties']?.groupType=="EMPLOYEE"){
                  currentImageName+= "assigned";
                }else{
                  if(d['properties']?.groupType=="HOTSEAT"){
                    currentImageName;
                  }else{
                    if(d.properties.groupType=='BLOCKED' ){
                      currentImageName+= "Unavailable";
                    }else{
                      if(d['properties']?.groupType=="TEAM" || d['properties']?.teamName){
                        this.FLOOR_DATA.extras.colorMapping.forEach(label=>{
                          if(Object.keys(label)[0]==team){
                            currentImageName = 'team/'+label[team]+'/'+currentImageName;
                          }
                        });
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }else{

        /** Assignement view asset mapping for 'with floor plan" */
        if(this.view=="assignment-view"){
          if(d.properties.groupType){
            if(d.properties.groupType=="EMPLOYEE"){
              if(d.properties?.bookedByDetails.length>0 && d.properties?.bookedByDetails[0].teamName){
                this.FLOOR_DATA.extras.colorMapping.forEach(label=>{
                  if(Object.keys(label)[0]==team){
                    currentImageName = 'team/'+label[team]+'/'+currentImageName;
                  }
                });
                currentImageName+= "Booked";
  
              }
            }else{
              if(d.properties.groupType=="TEAM"){
                this.FLOOR_DATA.extras.colorMapping.forEach(label=>{
                  if(Object.keys(label)[0]==team){
                    currentImageName = 'team/'+label[team]+'/'+currentImageName;
                  }
                });
                currentImageName+= "Booked";
              }else{
                if(d.properties.groupType=="HOTSEAT"){
                  currentImageName = currentImageName;
                }else{
                  if(d.properties.groupType=="BLOCKED"){
                    currentImageName+= 'Unavailable';
                  }else{
                    if(d.properties.getTeamName=="AVAILABLE"){
                      currentImageName = currentImageName;
                    }
                  }
                }
              }
            }
  
          }
        }else if(this.view === 'sanitisation-view'){
          d.properties.isSanitized ? currentImageName += 'Sanitized' : currentImageName += 'Unsanitized';
        }
        else if(this.view === 'preferences-view'){
            switch (d.properties.status) {
              case 'Not Available':
                  currentImageName+= "Unavailable";
                  break;
              case 'AVAILABLE':
                  currentImageName = currentImageName;
                  break;
              case 'BOOKED':
                  if(d.properties.groupType === 'TEAM' || d.properties.groupType === 'HOTSEAT'){
                    currentImageName = currentImageName;
                  }
                  else currentImageName+= "Booked";
                  break;
              case 'SIGNED_IN':
                  if(d.properties.groupType === 'TEAM' || d.properties.groupType === 'HOTSEAT'){
                    currentImageName = currentImageName;
                  }
                  else currentImageName+= "Signedin";
                  break;
          }
        }
        else{
          /**Employee view asset mapping for 'with floor plan""*/
          switch (d.properties.status) {
              case 'Not Available':
                  currentImageName+= "Unavailable";
                  break;
              case 'AVAILABLE':
                  currentImageName = currentImageName;
                  break;
              case 'BOOKED':
                  currentImageName+= "Booked";
                  break;
              case 'SIGNED_IN':
                  currentImageName+= "Signedin";
          }
        }


      }
      
      
    }
    d3.select(baseGroup).attr('id', ID)
    d3.select(baseGroup).style("cursor", "pointer").attr("type", "SEAT").attr("seatId", ID);
    let seatPlacementPromise = new Promise((resolve,reject)=>{
      // d3.xml(`${this.assetsLocation}/${currentImageName}.svg`).then((data)=>{
      let data = new DOMParser().parseFromString(this.assetsCache[`${this.assetsLocation}/${currentImageName}.svg`], 'text/xml')
          d3.select(baseGroup).append(()=>{
              let seatImg = d3.select(data.documentElement)
              .attr("imageName", currentImageName)
              .attr("width", width)
              .attr("height", height)
              .attr("id", ID + "SEAT")
              .attr("x", xPos)
              .attr("y", yPos)
              .attr("status", d.properties.status);
              if (seatColorCode) {
                  switch (d.properties.status) {
                  case "BOOKED":
                  case "SIGNED_IN":
                      seatImg.selectAll('*').style('fill', seatColorCode);
                      break;
                  case "AVAILABLE":
                      seatImg.selectAll('*').style('stroke', seatColorCode);
                      break;
                  }
              }
              this.inMemoryAsset[currentImageName] = data.documentElement;
              resolve(true);
              return data.documentElement;
          }
          );
      // });
    });

    d3.select(NODE).style("opacity", "0")
    // if(this.view !== "admin-view" && this.view !== "assignment-view" && d.properties.groupType === 'TEAM' && d.properties.status === 'AVAILABLE'){
    //   d3.select(baseGroup).select('path').style("fill", "#E2E8FA")
    //   d3.select(baseGroup).select('path').style("stroke", "#E2E8FA")
    //   d3.select(NODE).style("opacity", "1")
    // }

    d3.select(NODE?.parentElement)
      .style('transform-origin', `${xPos + (width / 2)}px ${yPos + (height / 2)}px`)
      .style('transform', function (d: any, i) {
        return 'rotate(' + (styles?.angle || 0) + 'deg)';
      });
    return seatPlacementPromise;
  }

  getTeamName(_id) {
    let teamName;
    if (this.FLOOR_DATA.planDetails.floorSeatsDTOMap[_id]) {
      teamName = this.FLOOR_DATA.planDetails.floorSeatsDTOMap[_id].teamName;
    }
    if (!teamName && this.FLOOR_DATA.planDetails.floorSeatsDTOMap[_id] && this.FLOOR_DATA.planDetails.floorSeatsDTOMap[_id].seatBookedBydetails && this.FLOOR_DATA.planDetails.floorSeatsDTOMap[_id].seatBookedBydetails[0]) {
      teamName = this.FLOOR_DATA.planDetails.floorSeatsDTOMap[_id].seatBookedBydetails[0].teamName;
    }
    return teamName;
  }

  getQueryStringValue(key) {
    let value = "";
    if (window.location.href) {
      const queryStringPairs = window.location.href.split('?')[1] && window.location.href.split('?')[1].split('&');
      if (queryStringPairs) {
        for (let i = 0; i < queryStringPairs.length; i++) {
          const pair = queryStringPairs[i].split('=');
          if (pair[0] === key) {
            value = pair[1];
            break;
          }
        }
      }
      return value;
    }
    return '';
  }

}
